import { Injectable } from '@angular/core';
import { BullhornEntityTypes } from 'datasource-service-lib';
import { IIconService } from 'interfaces-lib';

@Injectable({ providedIn: 'root' })
export class BullhornIconService implements IIconService {
  getIcon(type: string): string {
    type = type?.toLowerCase();
    switch (type) {
      case BullhornEntityTypes.Candidate.toLowerCase():
        return 'bullhorn-icon bhi-candidate';
      case BullhornEntityTypes.ClientContact.toLowerCase():
        return 'bullhorn-icon bhi-person';
      case BullhornEntityTypes.ClientCorporation.toLowerCase():
      case BullhornEntityTypes.Company.toLowerCase():
        return 'bullhorn-icon bhi-company';
      case BullhornEntityTypes.JobOrder.toLowerCase():
        return 'bullhorn-icon bhi-job';
      case BullhornEntityTypes.Placement.toLowerCase():
        return 'bullhorn-icon bhi-star';
      case BullhornEntityTypes.Lead.toLowerCase():
        return 'bullhorn-icon bhi-lead';
      case BullhornEntityTypes.Opportunity.toLowerCase():
        return 'bullhorn-icon bhi-opportunity';
      case BullhornEntityTypes.Appointment.toLowerCase():
        return 'bullhorn-icon bhi-appointment';
      case BullhornEntityTypes.Task.toLowerCase():
        return 'bullhorn-icon bhi-check-o';
      case BullhornEntityTypes.Note.toLowerCase():
        return 'bullhorn-icon bhi-add-note';
      case BullhornEntityTypes.JobSubmission.toLowerCase():
        return 'bullhorn-icon bhi-star-o';
      case 'namespace':
        return 'bhi-bull';
      default:
        return '';
    }
  }
}
